import axios from 'axios';
const uninterceptedAxiosInstance = axios.create();
uninterceptedAxiosInstance.defaults.baseURL = process.env.VUE_APP_API_URL;

const state = {};
const getters = {};
const mutations = {};

const actions = {
  isValidToken(state, token) {
    return uninterceptedAxiosInstance.get(`/donations-over-the-phone/sms/token-validation?token=${token}`)
      .then(({ data }) => (data))
      .catch((err) => { throw err; });
  },
  processPayment(state, payload) {
    return uninterceptedAxiosInstance.post(`/donations-over-the-phone/process-payment`, payload)
      .then(({ data }) => (data))
      .catch((err) => { throw err; });
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};